import { useTranslation } from "react-i18next";
import { Table, Badge } from "@/shared/ui";
import type { SortConfig } from "@/shared/utils";
import { getRequestStatusConfig, formatWarehouseDate } from "../utils";
import type { ItemRequestListItem } from "../types";
import type { RequestSortKey } from "../hooks";

interface Props {
  items: ItemRequestListItem[];
  onOpenDetail: (id: number) => void;
  sortConfig: SortConfig<RequestSortKey> | null;
  onSort: (key: RequestSortKey) => void;
}

export default function ItemRequestsTable({
  items,
  onOpenDetail,
  sortConfig,
  onSort,
}: Props) {
  const { t } = useTranslation("WarehousePage");

  return (
    <Table.Table>
      <Table.Header>
        <tr>
          <Table.HeadCell
            sortable
            sortDirection={sortConfig?.key === "itemName" ? sortConfig.direction : undefined}
            onSort={() => onSort("itemName")}>
            {t("requests.table.itemName")}
          </Table.HeadCell>
          <Table.HeadCell
            sortable
            sortDirection={sortConfig?.key === "quantity" ? sortConfig.direction : undefined}
            onSort={() => onSort("quantity")}>
            {t("requests.table.quantity")}
          </Table.HeadCell>
          <Table.HeadCell>{t("requests.table.requestedBy")}</Table.HeadCell>
          <Table.HeadCell
            sortable
            sortDirection={sortConfig?.key === "status" ? sortConfig.direction : undefined}
            onSort={() => onSort("status")}>
            {t("requests.table.status")}
          </Table.HeadCell>
          <Table.HeadCell
            sortable
            sortDirection={sortConfig?.key === "createdAt" ? sortConfig.direction : undefined}
            onSort={() => onSort("createdAt")}>
            {t("requests.table.createdAt")}
          </Table.HeadCell>
        </tr>
      </Table.Header>
      <Table.Body>
        {items.map((item) => {
          const statusConfig = getRequestStatusConfig(item.status);

          return (
            <Table.Row key={item.id} onClick={() => onOpenDetail(item.id)} className="cursor-pointer">
              <Table.Cell isBold>{item.item_name}</Table.Cell>
              <Table.Cell>{item.quantity}</Table.Cell>
              <Table.Cell>{item.requested_by_name}</Table.Cell>
              <Table.Cell>
                <Badge
                  variant="soft"
                  color={statusConfig.color}
                  text={t(`requests.status.${item.status}`)}
                  icon={statusConfig.icon}
                />
              </Table.Cell>
              <Table.Cell>{formatWarehouseDate(item.created_at)}</Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table.Table>
  );
}
